import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { NOJOOM_HISTORY_API } from "../../services/common/endpoints";
import { GetCacheKey,isContainAlphabet  } from "../../services/common/utils";
import Loadingcomponent from "../loader/loadingcomponent";
import {CT_Events} from "../../analytics/CTEvents";
import NojoomPointsHistoryShimmer from "../../ShimmerEffect/nojoom-points-history-shimmer";

const NojoomPointsHistory = ({ pmsData }) => {
    const mSISDNIdInfo =
        pmsData?.response?.ListOfMSISDNLoyMember?.length > 0
            ? pmsData?.response?.ListOfMSISDNLoyMember[0]
            : null;
    const navigate = useNavigate()
    const { t } = useTranslation();
    const {CT_NojoomPointHistory} = CT_Events();
    const {
        data: { data } = {},
        isLoading,
        error,
        isFetching,
        isError,
        isLoadingError,
        isSuccess
    } = useQuery([GetCacheKey("ooredeo-rewards"), NOJOOM_HISTORY_API, { type: "all", membernumber: mSISDNIdInfo?.MemberNumber }, {}], {
        retry: false,
        retryOnMount: true,
        cacheTime: 30000,
        staleTime: 30000,
        onSuccess: ({data: resData}) =>{
            if(resData?.status == 0){
                try{
                    CT_NojoomPointHistory("Success", resData?.message);
                }catch{}
            }else{
                try{
                    CT_NojoomPointHistory("Failure", resData?.message);
                }catch{}
            }
        }
    });
    return (
        <div>

            <div class="d-flex justify-content-between mb-3 mt-3 align-items-center">
                <h2 class="page_title_v1 mb-0">{t("pointsHistory")}</h2>
                <div onClick={() => navigate("/nojoom-points-history-page", { state: mSISDNIdInfo?.MemberNumber })}>
                    <img src={process.env.PUBLIC_URL + '/assets/images/sort.svg'} alt="" title="" class="pointer" />
                </div>
            </div>

            <div class="white_card p-3 mb-5">
                {(isLoading || isFetching) ? <NojoomPointsHistoryShimmer /> :
                    ((error || isError || isLoadingError) ? <section class="">
                        <div class="bottom_bg_section">
                            <div class="bottom_bg_section_container">
                                <img src="assets/images/assets_bg.jpg" alt="" />
                            </div>
                        </div>
                        <div class="center_section">
                            <div class="sec_top mt-160">
                                <div class="pse_md">
                                    <div class="text-center mb-5">
                                        <div class="mb-5">
                                            <picture>
                                                <img src={process.env.PUBLIC_URL + '/assets/images/error_red.svg'} width="{100px}" alt="" title="" />
                                            </picture>
                                        </div>
                                        <div>
                                            <h2 class="mb-2 page_title_v1 primary_color">{t("errorMsg")}</h2>
                                            <p class="mb-3 primary_14 dark_gray_color">{t("somethingwentwrong")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> :
                        ((Number(data?.status) === -1) ? <>
                            <div className="xpress_no_trans text-center" >
                                <img
                                    src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                                    alt=""
                                    title=""
                                />
                                <div className="mb-5">
                                    <label>{data?.message}</label>
                                </div>
                            </div>
                        </> : data?.response?.History?.slice(0, 5)?.map(res => {
                            return (
                                <>

                                    < div class="d-flex justify-content-between align-items-center" >
                                        <div className="twocoloum_txt_restrct">
                                            <h6 class="regular_14">{res?.points} {t("Points")}</h6>
                                            {/* <p class="mt-2 mb-0 support_text_grey_12">{res?.source}</p> */}
                                            <p
                                            class=" mb-0 support_text_grey_12"
                                            style={{"direction":isContainAlphabet(res?.source) ? "ltr" :""} }
                                            // className={
                                            //     isContainAlphabet(res?.source)
                                            //       ? "mt-2 mb-0 support_text_grey_12 profile_info_desc_rtl"
                                            //       : "mt-2 mb-0 support_text_grey_12"
                                            //   }
                                            >{res?.source}</p>

                                        </div>
                                        <div>
                                            <p class="mb-0 support_text_grey_12">{res?.rntransactiondate}</p>
                                        </div>
                                        <div className="ar-tick-icon">
                                            <img src={res?.status_icon || res?.status_rnicon} alt="" title="" class="img-w22" />
                                        </div>
                                    </div>
                                    <hr />

                                </>
                            )
                        })))
                }


                {/* <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h6 class="regular_14">500 Points</h6>
                        <p class="mt-2 mb-0 support_text_grey_12">Earned points</p>
                    </div>
                    <div>
                        <p class="mb-0 support_text_grey_12">20-Jun-2021</p>
                    </div>
                    <div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/ra_tick.svg'} alt="" title="" class="img-w22" />
                    </div>
                </div>
                <hr />
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h6 class="regular_14">500 Points</h6>
                        <p class="mt-2 mb-0 support_text_grey_12">Earned points</p>
                    </div>
                    <div>
                        <p class="mb-0 support_text_grey_12">20-Jun-2021</p>
                    </div>
                    <div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/ra_cross.svg'} alt="" title="" class="img-w22" />
                    </div>
                </div>
                <hr />
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h6 class="regular_14">500 Points</h6>
                        <p class="mt-2 mb-0 support_text_grey_12">Earned points</p>
                    </div>
                    <div>
                        <p class="mb-0 support_text_grey_12">20-Jun-2021</p>
                    </div>
                    <div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/ra_tick.svg'} alt="" title="" class="img-w22" />
                    </div>
                </div> */}
            </div>
        </div >

    );
};

export default NojoomPointsHistory;